(function(){
  // API key restricted to farmsteady.com referrer in Google Cloud Console
  const KEY = "AIzaSyCFZJBkOvTGhOGa8_E-6YfORp1w8j8dcrA";
  const CHANNEL = "UCbWeQK1KUF9v0aZJA2Lx3hw";
  const MAX = 5;
  const TTL = 216e5; // 6h

  const feed = document.getElementById("fs-shorts-feed");
  if (!feed) return;

  const ISOsec = (i) => {
    const m = /PT(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?/.exec(i) || [];
    return (+m[1]||0)*3600 + (+m[2]||0)*60 + (+m[3]||0);
  };

  const thumb = (v) => {
    const d = document.createElement("div");
    d.className = "fs-thumb";
    d.style.backgroundImage = `url(https://i.ytimg.com/vi/${v.id}/hqdefault.jpg)`;
    d.dataset.id = v.id;
    d.dataset.ttl = v.title || "";
    return d;
  };

  const toIframe = (el) => {
    const id = el.dataset.id;
    if (!id) return;
    const f = document.createElement("iframe");
    f.className = "fs-shorts-iframe";
    f.loading = "lazy";
    f.allow = "accelerometer;autoplay;clipboard-write;encrypted-media;gyroscope;picture-in-picture;web-share";
    f.allowFullscreen = true;
    f.title = el.dataset.ttl || "Video";
    f.src = `https://www.youtube.com/embed/${id}?playlist=${id}&loop=1&playsinline=1&mute=1&modestbranding=1&autoplay=1`;
    el.replaceWith(f);
  };

  const injectLD = (videos, publisher) => {
    if (document.getElementById("fs-short-jsonld")) return;
    const logo = "https://farmsteady.com/cdn/shop/files/FarmSteady-Logo-One-Line-Website_1480x320.png";
    const ld = {
      "@context":"https://schema.org",
      "@graph": videos.map(v => ({
        "@type":"VideoObject",
        name: v.title || "",
        description: "",
        thumbnailUrl: `https://i.ytimg.com/vi/${v.id}/hqdefault.jpg`,
        uploadDate: v.publishedAt || "",
        embedUrl: `https://www.youtube.com/embed/${v.id}`,
        publisher: { "@type":"Organization", name: publisher || "FarmSteady",
          logo: { "@type":"ImageObject", url: logo } }
      }))
    };
    const s = document.createElement("script");
    s.id = "fs-short-jsonld";
    s.type = "application/ld+json";
    s.text = JSON.stringify(ld);
    document.head.appendChild(s);
  };

  // Shorts via uploads playlist (avoid search.list 403s)
  async function getShorts(){
    const k = `fs-s-${CHANNEL}`;
    try {
      const c = JSON.parse(localStorage.getItem(k) || "{}");
      if (c.d && Date.now()-c.t < TTL) return c.d;
    } catch(e){}

    const chUrl = `https://www.googleapis.com/youtube/v3/channels?part=contentDetails&id=${CHANNEL}&key=${KEY}`;
    const ch = await fetch(chUrl, { referrerPolicy: "origin" }).then(r => r.json());
    const uploadsId = ch?.items?.[0]?.contentDetails?.relatedPlaylists?.uploads;
    if (!uploadsId) throw new Error("No uploads playlist");

    const plUrl = `https://www.googleapis.com/youtube/v3/playlistItems?part=contentDetails&playlistId=${uploadsId}&maxResults=10&key=${KEY}`;
    const pl = await fetch(plUrl, { referrerPolicy: "origin" }).then(r => r.json());
    const ids = (pl.items || []).map(i => i.contentDetails?.videoId).filter(Boolean).join(",");
    if (!ids) throw new Error("No videos in uploads");

    const vUrl = `https://www.googleapis.com/youtube/v3/videos?part=snippet,contentDetails&id=${ids}&key=${KEY}`;
    const v = await fetch(vUrl, { referrerPolicy: "origin" }).then(r => r.json());

    const vids = (v.items || [])
      .filter(x => ISOsec(x.contentDetails?.duration || "") <= 60)
      .slice(0, MAX)
      .map(x => ({ id: x.id, title: x.snippet.title, publishedAt: x.snippet.publishedAt }));

    if (vids.length) try { localStorage.setItem(k, JSON.stringify({ t: Date.now(), d: vids })); } catch(e) {}
    return vids;
  }

  async function init(){
    try {
      const vids = await getShorts();
      if (!vids || !vids.length) throw new Error("No shorts");
      vids.forEach(v => feed.appendChild(thumb(v)));
      injectLD(vids, feed.dataset.publisher);

      // Center the middle thumbnail in the carousel — horizontal scroll only, never moves the page
      const items = feed.querySelectorAll(".fs-thumb");
      if (items.length > 2) {
        const mid = items[Math.floor(items.length / 2)];
        requestAnimationFrame(() => {
          feed.scrollLeft += mid.getBoundingClientRect().left
                           - feed.getBoundingClientRect().left
                           - (feed.clientWidth - mid.clientWidth) / 2;
        });
      }

      const io = new IntersectionObserver(ents => {
        ents.forEach(o => {
          if (o.isIntersecting){ toIframe(o.target); io.unobserve(o.target); }
        });
      }, { threshold: 0.1 });
      feed.querySelectorAll(".fs-thumb").forEach(n => io.observe(n));
    } catch(e) {
      console.error("[fs-shorts] Unable to load Shorts", e);
      feed.innerHTML = '<p style="padding:1rem">Unable to load Shorts.</p>';
    }
  }

  (window.requestIdleCallback || (cb => setTimeout(cb, 0)))(init);
})();